// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","var-drawer-box-shadow":"0px -1px 8px 0px rgba(0,0,0,.15)","cta-drawer":"cta-drawer-b0a"};